import { PathWithId } from "@constellation-academy/epic-ui";
import { ProductEditPath } from "../product-edit/product-edit.paths";

export class ProductsPath extends PathWithId<typeof ProductsPath> {
	static readonly pathKey = "products";
	static readonly idKey = "productId";
	static readonly childPaths = [ProductEditPath];
}
